// CID Agent PWA API layer
// Module: Internal co-share — asking the agent who holds a listing to work the deal
// together, and answering that ask.
//
// Another agent's listing carries no paperwork action of its own any more: the
// servers refuse a booking form or a sale written against it. This is the path that
// replaced it —
//
//   request  → the lister accepts or rejects (both sides are notified)
//   accepted → the LISTER raises the sale, with the requester on it as a co-agent
//              (SaleCreatePage sends co_share_request_id; sale.service pins them in)
//
// Every list (collection GET) takes params { page, limit, ...filters }.
import client from './client';

/**
 * POST /api/agent/listings/:id/co-share-requests
 * Ask to co-share another agent's listing. Body: { message, proposed_split_percentage }.
 * Refused on your own listing, on HQ stock, and on anything not ACTIVE + PUBLIC.
 */
export const createCoShareRequest = (listingId, data = {}) =>
  client.post(`/api/agent/listings/${listingId}/co-share-requests`, data);

/**
 * GET /api/agent/co-share-requests [LIST · paginated]
 * The caller's two inboxes: box='incoming' (asked of me — I hold the listing),
 * 'outgoing' (I asked), or 'all'. `status` accepts a comma list.
 */
export const listCoShareRequests = (params = {}, config = {}) =>
  client.get(`/api/agent/co-share-requests`, { params, ...config });

/**
 * GET /api/agent/co-share-requests/summary
 * Badge counts: { incoming_pending, incoming_accepted, outgoing_pending,
 * outgoing_accepted, actionable }.
 */
export const getCoShareSummary = () => client.get(`/api/agent/co-share-requests/summary`);

/** GET /api/agent/co-share-requests/:id — one request, from whichever side you are on. */
export const getCoShareRequestById = (id) => client.get(`/api/agent/co-share-requests/${id}`);

/**
 * PATCH /api/agent/co-share-requests/:id/accept
 * Lister only. Body: { agreed_split_percentage, response_note }. The agreed figure
 * is what seeds the requester's share when the sale is raised.
 */
export const acceptCoShareRequest = (id, data = {}) =>
  client.patch(`/api/agent/co-share-requests/${id}/accept`, data);

/** PATCH /api/agent/co-share-requests/:id/reject — lister only. Body: { response_note }. */
export const rejectCoShareRequest = (id, data = {}) =>
  client.patch(`/api/agent/co-share-requests/${id}/reject`, data);

/**
 * PATCH /api/agent/co-share-requests/:id/withdraw
 * Either side pulls out, before or after acceptance — which is also what frees the
 * pair to agree a co-share on that listing again later. Body: { response_note }.
 */
export const withdrawCoShareRequest = (id, data = {}) =>
  client.patch(`/api/agent/co-share-requests/${id}/withdraw`, data);
